import { useTranslation } from 'react-i18next';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip } from 'recharts';
import type { TopicMastery } from '../../types/admin';

interface Props {
  data: TopicMastery[];
}

export default function TopicRadarChart({ data }: Props) {
  const { t } = useTranslation();
  if (data.length === 0) {
    return <div className="flex h-48 items-center justify-center text-sm text-slate-500 dark:text-slate-400">{t('dashboard.topicMastery.empty')}</div>;
  }

  const chartData = data.map((tp) => ({
    topic: tp.topic.length > 20 ? tp.topic.slice(0, 18) + '...' : tp.topic,
    mastery: tp.mastery_percent,
    fullTopic: tp.topic,
  }));

  return (
    <div role="img" aria-label={t('dashboard.topicMastery.ariaLabel')}>
      <ResponsiveContainer width="100%" height={300}>
        <RadarChart data={chartData} cx="50%" cy="50%" outerRadius="70%">
          <PolarGrid className="stroke-slate-200 dark:stroke-white/10" />
          <PolarAngleAxis dataKey="topic" tick={{ fontSize: 9 }} className="text-slate-600 dark:text-slate-400" />
          <PolarRadiusAxis domain={[0, 100]} tick={{ fontSize: 9 }} className="text-slate-400 dark:text-slate-500" />
          <Tooltip
            contentStyle={{ backgroundColor: '#141C2B', border: '1px solid rgba(255,255,255,0.13)', borderRadius: '12px', fontSize: 12, color: '#EEF2F8' }}
            formatter={(value) => [`${value}%`, t('dashboard.topicMastery.tooltipLabel')]}
            labelFormatter={(_, payload) => payload?.[0]?.payload?.fullTopic ?? ''}
          />
          <Radar dataKey="mastery" stroke="#2563EB" fill="rgba(37,99,235,0.3)" fillOpacity={1} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
